import { apiRequest } from './queryClient';
import { getApiBaseUrl } from '@/config/production';

// Garantir que não há barra dupla na construção da URL
const getApiBase = () => {
  const base = getApiBaseUrl();
  return base.replace(/\/+$/, ''); // Remove barras finais
};

const API_BASE = `${getApiBase()}/api`;

// Cliente API para compatibilidade com axios
export const apiClient = {
    get: async (url: string, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('GET', `${API_BASE}${url}`, undefined, options?.headers);
        const data = await response.json();
        return { data };
    },
    post: async (url: string, data?: any, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('POST', `${API_BASE}${url}`, data, options?.headers);
        const responseData = await response.json();
        return { data: responseData };
    },
    put: async (url: string, data?: any, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('PUT', `${API_BASE}${url}`, data, options?.headers);
        const responseData = await response.json();
        return { data: responseData };
    },
    patch: async (url: string, data?: any, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('PATCH', `${API_BASE}${url}`, data, options?.headers);
        const responseData = await response.json();
        return { data: responseData };
    },
    delete: async (url: string, options?: { headers?: Record<string, string> }) => {
        const response = await apiRequest('DELETE', `${API_BASE}${url}`, undefined, options?.headers);

        if (response.status === 204 || response.statusText === 'No Content') {
            return { data: {} };
        }

        const text = await response.text();
        if (!text) {
            return { data: {} };
        }

        try {
            return { data: JSON.parse(text) };
        } catch (error) {
            console.warn('Erro ao fazer parse da resposta DELETE:', error);
            return { data: {} };
        }
    }
};
